module.exports = __webpack_public_path__ + "img/IMG_3539_L_Wood_MockedUp.cb1548c4.jpg";